import Component from '@bythepixel/component-loader';

const selectors = {
  modalContainer: '.modal__container',
  modalCloseBtn: '.modal__close',
  subModelCard: '[data-sub-model-modal-trigger]',
};

// Sub-model modal component
export default class SubModelModal extends Component {
  static selector = selectors.modalContainer;
  static loaderPriority = 'in-view';

  constructor(el) {
    super(el);
    this.modalCloseBtn = el.querySelector(selectors.modalCloseBtn);

    this.bindEvents();
  }

  bindEvents() {
    this.$container.querySelectorAll(selectors.subModelCard).forEach(card => {
      card.addEventListener('click', (e) => {
        const modalTrigger = e.currentTarget.dataset.subModelModalTrigger;
        this.modalCloseBtn.click();
        document.querySelector(`[data-comp-modal-trigger="${modalTrigger}"]`).click();
      });
    });
  }
}
